import { StationeryProduct } from '@shared/utils/print-price/types';
import { useCallback } from 'react';
import { useProductAttributes } from '../../useProductAttributes';

type FoilValue = {
  optionId: string;
  colorId: string;
  assetThumbnailUrl: string;
};

const isValidFoil = (input: unknown): input is FoilValue => {
  return !!input;
};

export const useGetFoilConfigs = () => {
  const attributes = useProductAttributes();

  const getFoilConfigs = useCallback(
    (product: StationeryProduct, attributeId: string): FoilValue[] | undefined => {
      const allOptions = product.attributes.find(a => a.attributeId === attributeId)?.attributeOptions;

      return allOptions
        ?.map(dbOption => {
          // prettier-ignore
          const feOption = attributes
            .find(attr => attr.attributeId === attributeId)?.options
            .find(opt => opt.optionId === dbOption.attributeOption.id);
          const value = feOption?.value;
          if (!value) return null;

          return {
            colorId: feOption.value,
            assetThumbnailUrl: feOption?.assetThumbnailUrl,
            optionId: dbOption.attributeOption.id,
          };
        })
        .filter(isValidFoil);
    },
    [attributes],
  );

  return { getFoilConfigs };
};
